import studentHealth from '@/api/student-health'
import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  healthCategories: [],
  programs: []
}

export const getters = {
  getTermByYearGetter: state => ac_year_id => {
    return state.programs.filter(p => p.ac_year_id == ac_year_id)
  },

  getSubProgramByTermGetter: state => ac_term_id => {
    return state.programs.filter(p => p.ac_term_id == ac_term_id)
  },

  getGradeBySubProgramGetter: state => acps_id => {
    return state.programs.filter(p => p.acps_id == acps_id)
  }
}

export const mutations = {
  ...baseMutations,
  SET_HEALTH_CATEGORIES(state, data) {
    state.healthCategories = data
  },
  SET_PROGRAMS(state, data) {
    state.programs = data
  }
}

export const actions = {
  store(context, data) {
    return studentHealth.store(data)
  },
  async find(context, id) {
    let response = await studentHealth.find(id)
    return Promise.resolve(response)
  },
  async getProgramByStudent(context, student_id) {
    let response = await studentHealth.getProgramByStudent(student_id)
    context.commit('SET_PROGRAMS', response)
  },

  async dataBeforeCreate(context) {
    if (!context.state.healthCategories.length > 0) {
      let response = await studentHealth.healthCategory()
      context.commit('SET_HEALTH_CATEGORIES', response)
    }
  }
}
